import { serviceIDs } from './services'

export const CUSTOMER_ACCESS_TOKEN = 'customer_access_token'
export const CUSTOMER_SESSION_TOKEN = 'customer_session_token'
export const BOULEVARD_PUBLIC_API_TOKEN = 'boulevard_public_api_token'
export const BOULEVARD_AUTH_API_TOKEN = 'boulevard_auth_api_token'
export const IS_BOULEVARD_CLIENT = 'is_boulevard_client'

//Routes constants
export const SIGNUP_ROUTE = '/sign-up'
export const WELCOME_ROUTE = '/welcome'
export const LOGIN_ROUTE = '/login'
export const LOGIN_ROUTE_CUSTOM = '/login/from/:path'
export const SIGNUP_ROUTE_CUSTOM = `${SIGNUP_ROUTE}/from/:path`
export const FORGET_ROUTE = '/forget'
export const FORGET_SUCCESS_ROUTE = '/forget-success'
export const LOCATIONS_ROUTE = '/locations'
export const ESTHETICIAN_LIST_ROUTE = '/esthetician-list'
export const ENHANCEMENT_ROUTE = '/enhancement'
export const HEALTH_CHECK_ROUTE = '/health-check'
export const APPOINTMENT_CONFIRMATION_ROUTE = '/appointment-confirmation'
export const CONFIRM_APPOINTMENT_ROUTE = '/confirmed-appointment'
export const SHARE_APPOINTMENT_ROUTE = '/share-appointment'
export const FORGET_ROUTE_CUSTOM = `${FORGET_ROUTE}/from/:path`
export const FORGET_SUCCESS_ROUTE_CUSTOM = `${FORGET_SUCCESS_ROUTE}/from/:path`

export const MEMBERSHIP = '/membership'
export const MEMBERSHIP_MAIN_ROUTE = `${MEMBERSHIP}/*`
export const MEMBERSHIP_APPOINTMENT_CONFIRMATION_ROUTE = `${MEMBERSHIP}/confirmation`
export const MEMBERSHIP_CONFIRMATION_ROUTE = '/confirmation'
export const MEMBERSHIP_EXISTING_USER = '/existing-user'
export const MEMBERSHIP_EXISTING_USER_MAIN_ROUTE = `${MEMBERSHIP}/existing-user`
export const MEMBERSHIP_NO_APPOINTMENT = '/no-appointment'
export const MEMBERSHIP_UPCOMING_APPOINTMENT = '/upcoming-appointment'
export const MEMBERSHIP_LOCATIONS_ROUTE = `${MEMBERSHIP}/locations`
export const GROUP_BOOKING = '/group-booking'
export const LASER = '/laser'
export const LASER_MAIN_ROUTE = `${LASER}/*`
export const LASER_ESTHETICIAN_LIST_ROUTE = `${LASER}/esthetician-list`
export const LASER_HEALTH_CHECK_ROUTE = `${LASER}/health-check`
export const LASER_APPOINTMENT_CONFIRMATION_ROUTE = `${LASER}/appointment-confirmation`
export const FACIALS_ROUTE = `/facials`
export const FACIAL_CHECK_IN_ROUTE = `/facial-check-in`

export const LASER_CONFIRM_APPOINTMENT_ROUTE = `${LASER}/confirmed-appointment`
export const BLVD_LOGIN_LINK = 'https://blvd.app/@heyday/login '
export const INFLUENCER = '/influencer'
export const NYCA = '/nylamarket'
export const PHIL_MV = '/phildmvatlmarket'
export const INFLUENCER_NYCA = `${INFLUENCER}${NYCA}/*`
export const INFLUENCER_PHIL_MV = `${INFLUENCER}${PHIL_MV}/*`

// Location state config
export const LOCATION_STATE_CONFIG: Record<string, string> = {
  CA: 'California',
  NY: 'New York',
  PA: 'Pennsylvania',
  MD: 'Maryland',
  VA: 'Virginia',
  GA: 'Georgia',
  IL: 'Illinois',
  TX: 'Texas',
  MI: 'Michigan',
  CO: 'Colorado',
  AZ: 'Arizona',
  DC: 'Washington, DC',
  MA: 'Massachusetts',
  MN: 'Minnesota',
  AL: 'Alabama',
  AK: 'Alaska',
  AR: 'Arkansas',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  HI: 'Hawaii',
  ID: 'Idaho',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  UT: 'Utah',
  VT: 'Vermont',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
}

export const RETURNING_NON_MEMBER_BANNER_CITIES = [
  '14th St.',
  'Old Town Alexandria',
  'Bethesda Row',
  'Buckhead',
  'Midtown',
  'Perimeter',
  'Krog District',
  'East Cobb',
]

export const NO_TOKEN_FOUND = 'No Token Found'

export const NOMAD_DEV_LOCATION_ID =
  'urn:blvd:Location:c496ea57-0a49-473f-9558-8ffb1a10b68a'
export const UPPER_EAST_SIDE_LOCATION_ID =
  'urn:blvd:Location:49e97c04-1421-44a3-a37f-78fbfd8a87bb'

export const LASER_FACIAL_LOCATION =
  process.env.REACT_APP_ENV === 'development'
    ? NOMAD_DEV_LOCATION_ID
    : UPPER_EAST_SIDE_LOCATION_ID

export const AMEX_CARD = '9999 9999 9999 999'
export const NON_AMEX_CARD = '9999 9999 9999 9999'

export const GROUP_LIST = [
  {
    id: 1,
    title: "Get everyone's email.",
    subText:
      "We'll need each person's email address to book their appointment.",
  },
  {
    id: 2,
    title: 'Pick a date & time.',
    subText: "We'll help you plan a day that works for your group's schedule!",
  },
  {
    id: 3,
    title: 'Call the shop.',
    subText: 'Share the details & our hosts will take care of the rest.',
  },
]

const COMMON_PRICE = { tier1: 27500, tier2: 25000 }
const FIRST_FACIAL_PRICE = 9900

export const MEMBERSHIP_PRICES = [
  {
    service: serviceIDs?.[1],
    ...COMMON_PRICE,
  },
  {
    service: serviceIDs?.[3],
    ...COMMON_PRICE,
  },
  {
    service: serviceIDs?.[2],
    tier1: FIRST_FACIAL_PRICE,
    tier2: FIRST_FACIAL_PRICE,
  },
]

export const TIER1_LOCATIONS = [
  'Nomad',
  'Tribeca',
  'Upper East Side',
  'Upper West Side',
  'Noho',
  '19th Street',
  'Beverly',
  'Silver Lake',
  'Playa Vista',
  'Manhattan Beach',
  'Bethesda Row',
  'Alexandria',
  '14th St.',
  'Seaport',
  'Assembly Row',
  'Cobble Hill',
  'Kirkland',
  'Jersey City',
  'Williamsburg',
  'River Oaks',
  'Bellaire',
]

export const TIER2_LOCATIONS = [
  'Rittenhouse',
  'Plymouth Meeting',
  'Perimeter',
  'Midtown',
  'Buckhead',
  'Krog District',
  'East Cobb',
  'Ann Arbor',
  'Lincoln Park',
  'Tennyson',
  'University Hills',
  'Lowry',
  'Gilbert',
  'Scottsdale',
  'Woodbury',
  'Santa Monica',
]

export const MEMBERSHIP_FACIAL_PRICE = 8500
export const MEMBERSHIP_MAX_FACIAL_DISCOUNT = 3000
export const MEMBERSHIP_LASER_FACIAL_PRICE = 225
export const MEMBERSHIP_MICRONEEDLING_PRICE = 225
export const INFLUENCER_ENHANCEMENT_PRICE = 0
export const INFLUENCER_FACIAL_PRICE = 0
export const ENABLE_MEMBERSHIP_UPSELL = true
export const BLACK_FRIDAY_PROMO_CODE = '20OFFFACIALHOLIDAY'
export const GIFTORY_PROMO_CODE = 'GIFTORY'
export const SAY_HEY_PROMO_CODE = 'SAYHEY40'
export const FIRST_FACIAL_45_PROMO_CODE = 'FIRSTFACIAL45'
export const BLACK_FRIDAY_PROMO_START_DATE = '2023-11-24T05:00:00'
export const BLACK_FRIDAY_PROMO_END_DATE = '2023-11-28T05:00:00'
export const FACIAL_SERVICES_DESCRIPTION =
  "First time? Don't sweat it–we've got facials for every skin type, vibe, and mystery breakout. Let's find your perfect match."
export const FOUNDING_MEMBERSHIP_CITIES: string[] = []
export const FACIALS = ['Laser', '50 Minute', 'Microneedling']
export const DEFAULT_CURRENCY = 'USD'
export const FIRST_TIME_PROMOS = ['FIRSTGLOW', 'FIRSTFACIAL']
export const facialPreCheck = {
  header: 'In the last 7 days, have you had:',
  items: [
    'Botox or fillers',
    'Chemical peels',
    'Microneedling',
    'Microblading',
    'Dermaplaning',
    'Microdermabrasion',
    'Active/healing cold sore',
  ],
  footer: 'We ask you wait at least 14 days before getting your next facial.',
  chooseHeader: `Let's get some face time at a later date.`,
  chooseContent: `We want to be safe rather than sorry. Please select another
            appointment time that's 14 days after your most recent cosmetic
            treatment or cold sore.`,
  chooseContentBottom: '',
  note: '',
}

const microAndHydraFaciakData = {
  header: 'Have you recently been treated with / for any of the following:',
  items: [
    'Pregnancy, nursing, or trying to conceive',
    'Cancer',
    'Clotting or bleeding disorders',
    'Anticoagulant or blood disorder medications',
    'Autoimmune disease',
    'Diabetes',
    'Epilepsy',
    'Seizure disorders',
    'Tuberculosis',
    'Liver function issues',
    'Collagen formation disorders such as scleroderma',
    'Psoriasis',
    'Vitiligo',
    'Hepatitis',
    'HIV',
    'Allergy to stainless steel or topical anesthetics (lidocaine)',
    'Accutane use within the last 6 months',
    'Active inflammatory skin conditions (eczema, rosacea, dermatitis, rash, sunburn)',
  ],
  chooseHeader: "Let's find a better fit",
  chooseContentBottom:
    'For a tailored recommendation based on your skin concerns and goals, please contact your Heyday studio. One of our expert Estheticians will give you the best alternative.',
}

export const hydrafacialPreCheck = {
  header: microAndHydraFaciakData.header,
  items: microAndHydraFaciakData.items,
  footer:
    'If you have recently been treated for any of these conditions, a Hydrafacial is not recommended. You can click the back arrow and select another type of facial, or contact your Heyday studio and we will recommend another treatment for you to reach your skin goals.',
  chooseHeader: microAndHydraFaciakData.chooseHeader,
  chooseContent:
    'Although a Hydrafacial might not work for you, explore other facials, services, and add-on treatments that will be uniquely customized for your skin.',
  chooseContentBottom: microAndHydraFaciakData.chooseContentBottom,
  note: '',
}

export const microPreCheck = {
  header: microAndHydraFaciakData.header,
  items: microAndHydraFaciakData.items,
  footer:
    'If you have recently been treated for any of these conditions, or your plans post-facial include the activities above, Microneedling is not recommended. You can click the back arrow and select another type of facial or a different date, or contact your Heyday studio and we will recommend another treatment for you to reach your skin goals.',
  chooseHeader: microAndHydraFaciakData.chooseHeader,
  chooseContent:
    'Although Microneedling might not work for you, explore other facials, services, and add-on treatments that will be uniquely customized for your skin.',
  chooseContentBottom: microAndHydraFaciakData.chooseContentBottom,
  note: 'NOTE: for a minimum of 48 hours AFTER Microneedling, avoid activities such as swimming, hot yoga, sauna, steam rooms, sports and/or strenuous exercise. Do not perform any hair removal to the treated areas for at least one week post-facial and avoid sun exposure, tanning beds, sunless tanning lotions and cosmetic procedures during the course of your treatment.',
}

export const laserPreCheck = {
  header: 'Have you recently been treated with / for any of the following:',
  items: [
    'Accutane use within the past 6 months',
    'Botox, fillers, chemical peels, microblading or microneedling in the past 2 weeks',
    'Systemic steroid use',
    'Recent use of antibiotics',
    'Prescription anticoagulant',
    'Immunosuppressant medication',
    'Gold therapy (injection/oral)',
    'Impaired immune system/response',
    'History of skin cancer',
    'Lupus',
    'Vitiligo',
    'Seizure disorders',
    'Pregnant or trying to conceive, including IVF',
    'Recent sun exposure/tanning/sunless tanning within 1 week',
    'Active inflammatory disorders (eczema, rosacea, psoriasis, dermatitis)',
  ],
  footer:
    'A laser facial is not recommended at this time, but we are happy to recommend another treatment for you to reach your skin goals.',
  chooseHeader: "Let's get some face time at a later date.",
  chooseContent:
    "We want to be safe rather than sorry. Please select another appointment time that's 14 days after your most recent cosmetic treatment or cold sore.",
  chooseContentBottom: '',
  note: '',
}

export const fullEditFacialPreCheck = {
  header: facialPreCheck.header,
  items: [
    ...facialPreCheck.items,
    'Pregnancy or trying to conceive',
    'Accutane use within the past 6 months',
  ],
  footer:
    'If so, we ask you to wait before getting your next facial, or choose the Essential Facial if you are pregnant or trying to conceive, or have used Accutane recently. You can click the back arrow or the button below to make another selection, or contact your Heyday studio and we will recommend another treatment for you to reach your skin goals.',
  chooseHeader: "Let's find a better fit",
  chooseContent:
    'Although a Full Edit Facial might not work for you, explore other facials, services, and add-on treatments that will be uniquely customized for your skin.',
  chooseContentBottom:
    'For a tailored recommendation based on your skin concerns and goals, please contact your Heyday studio. One of our expert Estheticians will give you the best alternative.',
  note: '',
}

export const MEMBERSHIP_CATEGORIES = ['Memberships', 'Products']

export const INFLUENCER_FLOW_LOCATIONS_NYCA = [
  'Beverly',
  'Silver Lake',
  'Playa Vista',
  'Manhattan Beach',
  '19th Street',
  'Nomad',
  'Noho',
  'Tribeca',
  'Upper East Side',
  'Upper West Side',
]

export const INFLUENCER_FLOW_LOCATIONS_PHIL_MV = [
  'Bethesda Row',
  'Old Town Alexandria',
  '14th St.',
  'Perimeter',
  'Buckhead',
  'Midtown',
  'Krog District',
]

const PRICES = process.env.REACT_APP_BOOST_PRICES?.split(',')
export const BOOST_PRICES = PRICES?.map(Number) ?? []

export const GENERAL_REMAINDER_MICRONEEDLING =
  'Please arrive 15 minutes before your appointment start time so we can get you settled for an on-time start. Late arrivals may result in shortened appointments. After 10 minutes, your appointment will be canceled and you will incur a $25 cancellation fee.'

export const GENERAL_REMAINDER_OTHERS =
  'Please arrive 10 minutes before your appointment start time so we can get you checked in. Late arrivals may result in shortend appointments or rescheduling.'

export const PRIVACY_POLICY_LINK =
  'https://www.heydayskincare.com/pages/privacy-policy-terms-of-use'

export const APPOINTMENT_CONFIRMATION_MESSAGE =
  'For appointment scheduling and confirmation.'

export const DELUXE_HYDRAFACIAL_IDS = [
  'urn:blvd:Service:5ad9157a-23b5-46a4-be77-7a514ae54db1',
  'urn:blvd:Service:6338d323-0543-4fc7-8e05-472859ce1227',
  'urn:blvd:Service:cb36d9af-a5a2-4fef-84ef-ce8e87db5eec',
]
export const PREMIUM_HYDRAFACIAL_IDS = [
  'urn:blvd:Service:59634946-b4df-465a-bb36-d2469dad6186',
  'urn:blvd:Service:a0044318-6be9-4af4-946c-a6453802581e',
  'urn:blvd:Service:c2e5b0b8-0155-4e1e-9c5d-fb4969fa5ac9',
]
export const HYDRAFACIAL_IDS = [
  ...DELUXE_HYDRAFACIAL_IDS,
  ...PREMIUM_HYDRAFACIAL_IDS,
]

export const DELUXE_HYDRAFACIAL_MEMBERSHIP_PRICE = 25000
export const PREMIUM_HYDRAFACIAL_MEMBERSHIP_PRICE = 30000
export const FULL_EDIT_FACIAL_MEMBERSHIP_PRICE = 32500
